// Package Imports
import { toJS } from "mobx";

// Project Imports
import OptimizationStore from "../../store/OptimizationStore";
import changeLaApiCall from "../change-la/changeLaApiCall";
import * as APITypes from "constants/API";
import AuthStore from "../../../login/store/AuthStore";

const updateAddNeedFamilyProductId = async (
  apiRequest,
  familyProductIdData,
  needType
) => {
  let productListData = toJS(OptimizationStore.product_list_data);
  let needList = AuthStore.needMasterList;

  let isselectedNeed = needList.some((item) => item.unique_name == needType);

  productListData.map((item) => {
    item.data.forEach((value) => {
      if (isselectedNeed) {
        value.family_product_id = familyProductIdData.family_product_details_id;
      }
    });
    return item;
  });
  OptimizationStore.product_list_data = [...productListData];
  changeLaApiCall(familyProductIdData, needType, APITypes.ADD_NEW_NEED);
};

export default updateAddNeedFamilyProductId;
